module.exports = __webpack_public_path__ + "f7369a694ed0496fc889e2b0f09975d4.png";